<template>
  <header>
        <div class="flex-container p-grid">
            <div class="logo p-col-12 p-sm-3 p-md-2 p-lg-2 p-xl-2">
                <img :src="headerData.logo" alt="Image" />
            </div>
            <div class="banner p-col-12 p-sm-9 p-md-10 p-lg-10 p-xl-10">
                <h3 class="name">{{headerData.centerName}}</h3>
                <h3 class="background-red-color color-yeallow title">PHIẾU LIÊN LẠC ĐIỆN TỬ</h3>
                <div class="box p-grid" >
                <div class="left p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                    <div class="item">
                        <label for="">Lớp tại trung tâm: </label>
                        <h3>{{headerData.centerNameClass}}</h3>
                    </div>
                    <div class="item">
                        <label for="">Lịch học: </label>
                        <h3>{{headerData.calendarLearning}}</h3>
                    </div>
                </div>
                <div class="right p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                    <div class="item">
                        <label for="">Mã lớp:</label>
                        <h3>{{headerData.codeClass}}</h3>
                    </div>
                    <div class="item">
                        <label for="">Giáo viên dạy:</label>
                        <h3>{{headerData.teacherName}}</h3>
                    </div>
                </div>
            </div>
            </div>
        </div>
        <div>
            <!-- <div class="box p-grid" >
                <div class="left p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                    <div class="item">
                        <label for="">Lớp tại trung tâm: </label>
                        <h3>{{headerData.centerNameClass}}</h3>
                    </div>
                    <div class="item">
                        <label for="">Lịch học: </label>
                        <h3>{{headerData.calendarLearning}}</h3>
                    </div>
                </div>
                <div class="right p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                    <div class="item">
                        <label for="">Mã lớp:</label>
                        <h3>{{headerData.codeClass}}</h3>
                    </div>
                    <div class="item">
                        <label for="">Giáo viên dạy:</label>
                        <h3>{{headerData.teacherName}}</h3>
                    </div>
                </div>
            </div> -->
        </div>
    </header>
</template>

<script>
export default {
  name: 'Header',
  props: ['headerData'],
  components: {},
  data() {
    return {}
  },
  watch: {
  },
  created() {
  },
  methods: {
    
  }
}
</script>

<style>
</style>